import React from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import ClaytonLogo from 'pubweb-react-components/dist/images/svg/ClaytonLogo';
import LandingHeaderContainer from './LandingHeaderStyles';
import SiteInfo from '../SiteInfo';
import { ccpaScriptSource } from '../../services/settingService';
import { getSafeUrl } from "pubweb-smokey/dist/utils/utils";

if(typeof(window) !== "undefined" && typeof(document) !== "undefined" && !document.getElementById("ccpa_script")){
  let source = ccpaScriptSource;
  let script = document.createElement('script');
  script.src = source;
  script.defer = true;
  script.id = "ccpa_script";
  script.setAttribute("data-id", "ccpa-banner");
  script.setAttribute("data-first-link-text", "Privacy Policy");
  script.setAttribute("data-first-link-href", "https://www.claytonhomes.com/privacy/");
  document.getElementsByTagName("head")[0].appendChild(script);
}

const LandingHeader = () => {

    return (
        <LandingHeaderContainer>
            <Helmet>
            <html lang="en" />
            <title>Have It Made</title>
            <link rel="icon" type="image/x-icon" href="https://www.claytonhomes.com/images/favicon.ico?v=1" />
            <link rel="shortcut icon" type="image/png" href="https://www.claytonhomes.com/images/favicon.png?v=1" />
            <link rel="canonical" href={getSafeUrl()} />
            </Helmet>
            <SiteInfo />
            <Link to='/'>
                Home
                <ClaytonLogo
                    height="44"
                    rooftopColor="#FFFFFF"
                    letterColor="#FFFFFF"
                />
            </Link>
            <div className="header-rule" />
        </LandingHeaderContainer>
    );
}


export default LandingHeader;



// WEBPACK FOOTER //
// ./src/components/LandingHeader/LandingHeader.js